.mobile-filters-categories {
  color: #333333;
  background-color: #ffffff;
  border: 1px solid #e7e6e6;
  list-style: none;
  margin: 15px 13px 10px;
  padding: 0;
}

@media screen and (min-width: 980px) {
  .mobile-filters-categories {
    display: none;
  }
}

.mobile-filters-categories__item {
  margin: 0;
  padding: 0 15px;
}

.mobile-filters-categories__button {
  border-bottom: 1px solid #e7e6e6;
  display: block;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  padding: 15px 0 14px;
  position: relative;
  text-transform: capitalize;
  width: 100%;
}

:host(:not([dir="rtl"])) .mobile-filters-categories__button {
  text-align: left;
}

:host([dir="rtl"]) .mobile-filters-categories__button {
  text-align: right;
}

.mobile-filters-categories__button::after {
  border-bottom: 2px solid #9fa0a4;
  border-top-color: #9fa0a4;
  content: "";
  height: 8px;
  opacity: 0.7;
  position: absolute;
  top: 35%;
  width: 8px;
}

:host(:not([dir="rtl"])) .mobile-filters-categories__button::after {
  border-left-color: #9fa0a4;
  border-right: 2px solid #9fa0a4;
  right: 2px;
  transform: rotate(-45deg);
}

:host([dir="rtl"]) .mobile-filters-categories__button::after {
  border-right-color: #9fa0a4;
  border-left: 2px solid #9fa0a4;
  left: 2px;
  transform: rotate(45deg);
}